import { render } from "./FooterNav.vue?vue&type=template&id=673e7e8e"
import script from "./FooterNav.vue?vue&type=script&lang=js"
export * from "./FooterNav.vue?vue&type=script&lang=js"

import "./FooterNav.vue?vue&type=style&index=0&id=673e7e8e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__